import { Image } from '@/components/client';

import { TYPOGRAPHY_IMAGES } from '../../constants';

type BenefitHeaderProps = {
  title: string;
  subtitle: string;
  headingId: string;
};

export const BenefitHeader = ({
  title,
  subtitle,
  headingId,
}: BenefitHeaderProps) => {
  const getImageBySubtitle = () => {
    if (subtitle === '13만원 혜택!') {
      return TYPOGRAPHY_IMAGES.benefitSubtitle13;
    }
    if (subtitle === '특별 혜택 100% 드려요') {
      return TYPOGRAPHY_IMAGES.benefitSubtitleSpecial;
    }

    return null;
  };

  const image = getImageBySubtitle();

  return (
    <div className="flex flex-col items-center gap-6 text-center">
      <p className="font-700 text-Gray-800 typo-h5">{title}</p>
      <h2 id={headingId}>
        {image ? (
          <Image
            src={image.url}
            alt={image.alt}
            width={image.width}
            height={image.height}
            loading="lazy"
            className="object-contain"
          />
        ) : (
          <span
            style={{ fontFamily: 'Sandoll Hoyoyo' }}
            className="font-100 text-O-500 typo-h3"
          >
            {subtitle}
          </span>
        )}
      </h2>
    </div>
  );
};
